<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-table
        :loading="loading"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 370px)'}"
        :columns="columns"
        :data-source="list"
      
        :pagination="false"
      >
      <span slot="index" slot-scope="text, record,index">
       {{(current-1)*size+index+1}} 
      </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
      
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="current"
        :total="total"
        :page-size="pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
  </a-drawer>
</template>

<script>
import { pageRecord, addVoucher, updateVoucher,sendVoucher } from '@/api/user/voucher'
import {listUser} from "@/api/biz/user";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      pageNum:0,
      pageSize:10,
      total: 0,
      current: 1,
      size: 0,
      loading:false,
      submitLoading: false,
      formTitle: '',
      userList:[],
      id:0,
      isSend:false,
      // 表单参数
      form: {
        id: null,

        voucher:1,
        userId:null,
        remark: null,

      },
      list:[],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        voucher: [
          { required: true, message: '现金券数量不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户名称不能为空', trigger: 'blur' }
        ]
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 80,                    
          // fixed: 'left',
          scopedSlots: { customRender: 'index' },
         },
   
        {
          title: '操作前现金券余额',
          dataIndex: 'beforeVou',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作后现金券余额',
          dataIndex: 'afterVou',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '积分变动描述',
          dataIndex: 'descr',
          ellipsis: true,
          align: 'center'
        },
         {
           title: '操作来源',
           dataIndex: 'source	',
           scopedSlots: { customRender: 'createTime' },
           ellipsis: true,
           align: 'center',
           customRender:function (text) {
            if (text == 1) {
              return "课程赠送";
            }
            if (text == 2) {
              return "现金券消费";
            } else {
              return "新用户注册";
            }
          }
         },
         {
           title: '类型 ',
           dataIndex: 'type',
           ellipsis: true,
           align: 'center',
           customRender:function (text) {
            if (text == 1) {
              return "收入";
            } else {
              return "支出";
            }
          }
         },
        {
          title: '变动现金券',
          dataIndex: 'voucher',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
      
      ]
    }
  },
  filters: {
  },
  created () {
    this.initUser()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
    onClose () {
      this.open = false
      this.reset()
    },
    initUser(){
      listUser({status:1}).then(res=>{
        this.userList = res.data
      })
    },
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize
          
      pageRecord({id:this.id,pageNum:this.current}).then(res=>{
       
       this.list = res.data.records
       this.total = res.data.total
       this.current = res.data.current
       this.size = res.data.size
       this.loading = false
     })
    },
    changeSize (current, pageSize) {
      this.current = current
      this.pageSize = pageSize
     
      pageRecord({id:this.id,pageNum:this.current}).then(res=>{
       
        this.list = res.data.records
        this.total = res.data.total
        this.current = res.data.current
        this.size = res.data.size
        this.loading = false
      })
    },
    
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.isSend = false
      this.formType = 1
      this.form = {
        id: null,
        voucher: null,
        userId:null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '明细'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      console.log(row,"row")
      this.open = true
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      this.id = row.id
      this.isSend = true
      pageRecord({id:id,pageNum:this.current}).then(res=>{
       
        this.list = res.data.records
        this.total = res.data.total
        this.current = res.data.current
        this.size = res.data.size
        this.loading = false
      })
      this.formTitle = '明细'
    },

  }
}
</script>
